export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YK5silUs6yLUrwB0lw.d7dcc66d.woff2";